import http from "@/apps/shared/baseService/config";

const base = {
  rota: "fornecedors",
  nome: "Fornecedores"
};

export const service = {
  criar: data => http.post(`/admin/${base.rota}/create`, data),
  listar: data => http.post(`/admin/${base.rota}/list`, data),
  atualizar: data => http.post(`/admin/${base.rota}/update`, data),
  excluir: data => http.post(`/admin/${base.rota}/delete`, data),
  excluir_muitos: data => http.post(`/admin/${base.rota}/delete-many`, data)
};

const module = {
  actions: {
    listar_fornecedors: ({ commit, dispatch, getters }) => {
      dispatch("enableLoading");
      service
        .listar(getters.get_fornecedors_filtros)
        .then(res => {
          dispatch("disableLoading");
          commit("set_fornecedors", res.data);
        })
        .catch(e => {
          dispatch("disableLoading");
          dispatch("createGlobalMessage", {
            type: "error",
            message: e.response.data.message,
            timeout: 6000
          });
        });
    },
    atualizar_fornecedor: ({ commit, dispatch, getters }) => {
      dispatch("enableLoading");
      service
        .atualizar({ ...getters.get_fornecedor, imagens: getters.getLinks })
        .then(res => {
          dispatch("disableLoading");
          commit("set_fornecedor", res.data);
          dispatch("createGlobalMessage", {
            type: "success",
            message: "Atualização Concluída!",
            timeout: 6000
          });
          dispatch("listar_fornecedors");
        })
        .catch(e => {
          dispatch("disableLoading");
          dispatch("createGlobalMessage", {
            type: "error",
            message: e.response.data.message,
            timeout: 6000
          });
        });
    },
    criar_fornecedor: ({ commit, dispatch, getters }) => {
      dispatch("enableLoading");
      service
        .criar({ ...getters.get_fornecedor, imagens: getters.getLinks })
        .then(() => {
          dispatch("disableLoading");
          commit("set_fornecedor", {});
          commit("setLinks", []);
          dispatch("createGlobalMessage", {
            type: "success",
            message: "Registro Concluído!",
            timeout: 6000
          });
          dispatch("listar_fornecedors");
          commit("set_modal_view_fornecedor", false);
        })
        .catch(e => {
          dispatch("disableLoading");
          dispatch("createGlobalMessage", {
            type: "error",
            message: e.response.data.message,
            timeout: 6000
          });
        });
    },
    excluir_fornecedor: ({ dispatch, getters }, payload) => {
      dispatch("enableLoading");
      service
        .excluir(payload)
        .then(() => {
          dispatch("disableLoading");
          dispatch("createGlobalMessage", {
            type: "success",
            message: "Exclusão Concluída!",
            timeout: 6000
          });
          dispatch("listar_fornecedors");
        })
        .catch(e => {
          dispatch("disableLoading");
          dispatch("createGlobalMessage", {
            type: "error",
            message: e.response.data.message,
            timeout: 6000
          });
        });
    },
    excluir_fornecedors: ({ dispatch, getters }) => {
      dispatch("enableLoading");
      service
        .excluir(getters.get_fornecedors_marcados)
        .then(() => {
          dispatch("disableLoading");
          dispatch("createGlobalMessage", {
            type: "success",
            message: "Exclusão em massa Concluída!",
            timeout: 6000
          });
          dispatch("listar_fornecedors");
        })
        .catch(e => {
          dispatch("disableLoading");
          dispatch("createGlobalMessage", {
            type: "error",
            message: e.response.data.message,
            timeout: 6000
          });
        });
    },
    abre_modal_view_fornecedor: ({ commit, getters, dispatch }, payload) => {
      if (payload) {
        commit("set_fornecedor", payload);
        commit("setLinks", payload.imagens);
      }
      commit("set_modal_view_fornecedor", true);
    },
    fecha_modal_view_fornecedor: ({ commit }) => {
      commit("set_fornecedor", {});
      commit("setLinks", []);
      commit("set_modal_view_fornecedor", false);
    },
    add_fornecedor_marcado: ({ commit, getters }, payload) => {
      commit("set_fornecedors_marcados", [
        ...getters.get_fornecedors_marcados,
        payload
      ]);
    },
    remove_fornecedor_marcado: ({ commit, getters }, i) => {
      commit(
        "set_fornecedors_marcados",
        ...getters.get_fornecedors_marcados.filter((item, index) => index !== i)
      );
    }
  },
  state: {
    fornecedor: {},
    fornecedors: {
      docs: [],
      page: 1,
      totalPages: 1
    },
    fornecedors_marcados: [],
    fornecedors_filtros: {
      limitPerPage: 10,
      page: 1,
      dataInicio: "",
      dataFim: ""
    },
    modal_view_fornecedor: false
  },
  mutations: {
    set_fornecedor: (state, payload) => (state.fornecedor = payload),
    set_fornecedors: (state, payload) => (state.fornecedors = payload),
    set_fornecedors_marcados: (state, payload) =>
      (state.fornecedors_marcados = payload),
    set_modal_view_fornecedor: (state, payload) =>
      (state.modal_view_fornecedor = payload)
  },
  getters: {
    get_fornecedor: state => state.fornecedor,
    get_fornecedors: state => state.fornecedors,
    get_fornecedors_marcados: state => state.fornecedors_marcados,
    get_modal_view_fornecedor: state => state.modal_view_fornecedor,
    get_fornecedors_filtros: state => state.fornecedors_filtros
  }
};

const routes = [
  {
    path: `/${base.rota}`,
    component: () => import("./views/Listar.vue"),
    name: base.nome
  }
];

export default {
  service,
  module,
  routes
};
